import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

// TODO: Replace with your Firebase project configuration
// Get these values from Firebase Console > Project Settings > Your Apps
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

/**
 * Firebase Storage, for browser-direct uploads (support-form screenshots).
 * Null when no bucket is configured so callers can hide the upload UI rather
 * than let `ref()` throw "no default bucket" at the first click.
 */
export const storage = firebaseConfig.storageBucket ? getStorage(app) : null;

// Point sign-in at a local Firebase Auth emulator when one is configured, e.g.
//   REACT_APP_FIREBASE_AUTH_EMULATOR=http://127.0.0.1:9099 npm start
//
// Without this there is no way to exercise a real sign-in locally: the only
// alternative is authenticating against the production Firebase project, which
// means creating and deleting real user accounts to test a login flow.
//
// Inert in every deployed build — the variable is unset, so this never runs and
// the emulator import is the only cost. It is deliberately NOT keyed off
// NODE_ENV: a developer running against staging data should not be silently
// redirected to an emulator they did not start.
if (process.env.REACT_APP_FIREBASE_AUTH_EMULATOR) {
  connectAuthEmulator(auth, process.env.REACT_APP_FIREBASE_AUTH_EMULATOR, {
    disableWarnings: true,
  });
}

export default app;
